<template>
  <BaseDialog
    centered
    contentClass="estimationParams"
    ref="dialog"
    :persistent="false"
    @closeModal="closeDialog"
    :on-close="closeDialog"
    showHeader
  >
    <template slot="title"> {{ $t('estimation.estimation-documents.parameters') }} </template>
    <template slot="content">
      <slot name="content"> <EstimationParameters ref="estimationParameters" /> </slot>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import EstimationParameters from '@/components/page-opportunity-estimation/EstimationParameters';

export default {
  name: 'EstimationParametersDialog',
  components: {
    BaseDialog,
    EstimationParameters,
  },
  methods: {
    openDialog() {
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss">
.base-dialog__estimationParams {
  height: auto;
  max-height: 85% !important;
  min-width: 480px;
  width: 40%;
  position: relative;
  border-radius: $border-radius-root;
  top: auto;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    min-height: max-content;
    background: $color-white !important;

    &::-webkit-scrollbar-track {
      background-color: $color-neutral-pale;
    }

    &::-webkit-scrollbar {
      height: 0px;
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: $border-radius-large;
      background-color: $color-grey-pale;
    }
  }
}
</style>
